// extracted by mini-css-extract-plugin
export default {"container":"LeftMenu_container_pDxsM","subtitle":"LeftMenu_subtitle_Ewuhn","logo":"LeftMenu_logo__Sq_D"};